import Vue from 'vue'
import currencyFormatter from 'currency-formatter'
import store from '@/store/store';

Vue.prototype.$currency = currencyFormatter
declare module 'vue/types/vue' {
  interface Vue {
    $currency: currencyFormatter
  }
}

export const localCurrency = (value) => {
  const currency = store.getters.getCountry.currency ? store.getters.getCountry.currency : "COP";
  const formatter = new Intl.NumberFormat(undefined, {
    style: "decimal",
    currency: currency,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });
  return `$ ${formatter.format(value)}`;
}
